import {LocationsV2State, RootState, LocationV2} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';

type LocationGetter = GetterTree<LocationsV2State, RootState>;

export const initialState = (): LocationsV2State => {
  return {
    initialState,
    locationFilters: [],
    showPositions: false,
    showAddPositionDialog: false,
  };
};

export const getters: LocationGetter = {
  locationFilters: (state) => state.locationFilters,
  showPositions: (state) => true, // Hardcoded until we decide we want to be able to hide positions
  showAddPositionDialog: (state) => state.showAddPositionDialog,
};

export const mutations: MutationTree<LocationsV2State> = {
  toggleShowPositions(state, value) {
    state.showPositions = value;
  },
  toggleAddPositionDialog(state, value) {
    state.showAddPositionDialog = value;
  },
  addLocationFilter(state, value) {
    const filters: string[] = [];
    filters.push(value);
    Object.assign(state.locationFilters, filters);
  },
  removeLocationFilter(state, value) {
    const filters: string[] = state.locationFilters.filter((f) => f !== value);
    Object.assign(state.locationFilters, filters);
  },
  // removeAllLocationFilters(state) {
  //   Object.assign(state, initialState());
  // }
};

export const actions: ActionTree<LocationsV2State, RootState> = {

};

export const locationsV2: Module<LocationsV2State, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
